<template>
    <footer class="border-light border-top">
        <div class="elemento-grafico">
            <img src="../assets/svg/elemento-grafico.svg">
        </div>
        <div class="container">
            <div class="row d-md-flex align-items-md-center justify-content-md-between">
                <div class="col-sm-12 d-md-flex align-items-md-center justify-content-center justify-content-lg-start small py-4 py-md-5">
                    <div class="row d-md-flex align-items-md-start justify-content-md-between text-center text-lg-left p-md-0 w-100 mx-auto">
                        <div class="col-12 col-lg-2 mb-3 mb-md-0">
                            <a href="" target="_blank" title=""><img src="../assets/svg/logo-tds-gray.svg" height="40"></a>
                        </div>
                        <div class="col-12 col-lg-6">
                            <div class="row">
                                <div class="col-12 col-lg-6">
                                    <div class="text-uppercase font-weight-bold">{{$t('company_name')}}</div>
                                    <div><a href="http://maps.apple.com/?address=Via+delle+Macchine,+14,+30038+Spinea,+Venezia" v-html="$t('address')"></a></div>
                                    <div>{{$t('vat_number_label')}} {{$t('vat_number')}}</div>
                                </div>
                                <div class="col-12 col-lg-6 mt-3 mt-lg-0">
                                    <div><a href="tel:+39 041 990 320" :title="$t('phone_number')">{{$t('phone_number')}}</a></div>                                    
                                    <div><a :href="'mailto:'+ $t('email_address')">{{$t('email_address')}}</a></div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-lg-2 mt-3 mt-lg-0">
                            <div>
                                <router-link tag="a" :to="$i18nRoute({name:'home'})">{{$t('header.events')}}</router-link>
                            </div>
                            <div>
                                <router-link tag="a" :to="$i18nRoute({ name: 'circuiti'})">{{$t('header.paths')}}</router-link>
                            </div>
                            <div>
                                <router-link tag="a" :to="$i18nRoute({ name: 'servizi'})">{{$t('header.services')}}</router-link>
                            </div>
                            <div>
                                <router-link tag="a" :to="$i18nRoute({ name: 'chi-siamo'})">{{$t('header.about')}}</router-link>
                            </div>
                            <div>
                                <router-link tag="a" :to="$i18nRoute({ name: 'contatti'})">{{$t('header.contacts')}}</router-link>
                            </div>
                            <div>
                                <router-link tag="a" :to="$i18nRoute({ name: 'lavora-con-noi'})" v-if="currentLanguage === 'IT'">{{$t('header.jobs')}}</router-link>
                            </div>
                        </div>
                        <div class="language-switcher-wrapper">
                            <LanguageSwitcher/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-fluid bg-light py-4 border-light border-top">
            <div class="row">
                <div class="col-12 d-lg-flex align-items-md-center justify-content-md-center">
                    <ul class="nav">
                        <li class="nav-item">&copy; {{$t('company_name')}}</li>
                        <router-link tag="li" :to="$i18nRoute({ name: 'privacy-policy'})" class="nav-item">
                            <a class="nav-link">{{$t('privacy_policy_label')}}</a>
                        </router-link>
                        <router-link tag="li" :to="$i18nRoute({ name: 'cookie-policy'})" class="nav-item">
                            <a class="nav-link">{{$t('cookie_policy_label')}}</a>
                        </router-link>
                        <!--<li class="nav-item">-->
                            <!--<a class="nav-link" href="">{{$t('vat_number_label')}} {{$t('vat_number')}}</a>-->
                        <!--</li>-->
                        <li class="nav-item">
                            <a class="nav-link" :href="$t('credits_url')" target="_blank" :title="$t('credits_title')">{{$t('credits_label')}}</a>
                        </li>
                    </ul>
                </div>
                <div class="col-12 d-md-flex align-items-md-center justify-content-md-center">
                    <ul class="nav d-flex align-items-center justify-content-center mt-2 mt-lg-0">
                        <li class="nav-item">
                            <a class="nav-link pr-0" :href="$t('facebook_url')" target="_blank" :title="$t('facebook_title')">
                                <img src="../assets/svg/icons/icon-facebook.svg" height="25">
                            </a>
                        </li>
                        <li class="nav-item px-3 px-lg-0">
                            <a class="nav-link pr-0" :href="$t('instagram_url')" target="_blank" :title="$t('instagram_title')">
                                <img src="../assets/svg/icons/icon-instagram.svg" height="25">
                            </a>
                        </li>
                                                <li class="nav-item pl-0 pr-2 pl-lg-3">
                            <a class="nav-link pr-0" :href="$t('youtube_url')" target="_blank" :title="$t('youtube_title')">
                                <img src="../assets/svg/icons/icon-youtube.svg" height="25">
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link pr-0" :href="$t('camtv_url')" target="_blank" :title="$t('camtv_title')">
                                <img src="../assets/img/cam_tv.png" height="25">
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
    import LanguageSwitcher from './LanguageSwitcher'
    import { Trans } from '@/plugins/Translation'

    export default {
        name: 'TDSFoot',
        components: {
            LanguageSwitcher
        },
        data() {
            return {
                menu_isOpen: false,
                header: {
                    scroll_position: 0,
                    going_up: true,
                    min_position: 400,
                },
            }
        },mounted() {
            window.addEventListener('scroll',this.headScroll);
        },methods: {
            headScroll() {
                let old_pos = this.header.scroll_position

                let supportPageOffset = window.pageYOffset !== undefined
                let isCSS1Compat = ((document.compatMode || '') === 'CSS1Compat')
                // Verifico di quanto siamo scrollati verticalmente
                this.header.scroll_position = supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop

                if (this.header.scroll_position > old_pos)
                    this.header.going_up = false
                if (this.header.scroll_position < old_pos)
                    this.header.going_up = true

                if (this.header.scroll_position < this.header.min_position)
                    this.header.going_up = true
            },
        },computed: {
            currentLanguage () {
                return Trans.currentLanguage
            }
        }
    }
</script>
